export default "__VITE_ASSET__7dAOG6MJ__"